import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type { GlobalFunctionAdapter } from '@app/modules/assets/models/global-function.model';
import { GLOBAL_FUNCTION_PATH } from '@app/shared/constants/api-route.config';
import { WithAuditService } from '@app/shared/services/mixins/audit.service';
import { WithExportableService } from '@app/shared/services/mixins/export.service';
import { WithJobService } from '@app/shared/services/mixins/job.service';
import { WithLineageService } from '@app/shared/services/mixins/lineage.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { WithCrudVersionService } from '@app/shared/services/mixins/version.service';
import { WithWorkflowableService } from '@app/shared/services/mixins/workflow.service';
import { RestService } from '@app/shared/services/rest.service';
import { type TestCodeEvent, TestCodeService } from '@app/shared/services/test-code.service';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class GlobalFunctionService extends classes(
    WithCrudVersionService<GlobalFunctionAdapter>,
    WithAuditService,
    WithLogService,
    WithWorkflowableService,
    WithLineageService,
    WithExportableService,
    WithJobService,
) {
    protected endpoint = GLOBAL_FUNCTION_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
    private readonly testCodeService = inject(TestCodeService);

    runDebugCode(request: { id: number; code: string }): Observable<TestCodeEvent> {
        return this.testCodeService.run(`${this.endpoint}${request.id}/debug_code`, request.code);
    }
}
